import PropTypes from 'prop-types';
import { inventory } from './inventory';

export const expostProject = PropTypes.shape({
  id: PropTypes.number,
  intervention_zone_id: PropTypes.number,
  inventories: PropTypes.arrayOf(inventory),
  intermediate_cuttings: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number.isRequired,
    age: PropTypes.number.isRequired,
    extraction_ratio: PropTypes.number.isRequired,
    extraction_tree_proportion: PropTypes.number.isRequired,
    residue: PropTypes.number.isRequired,
    extracted_volume: PropTypes.number,
    commercial_purpose: PropTypes.oneOf(['PAPER', 'PLANK', 'SAW', 'STRUCTURAL']).isRequired
  })),
  final_cuttings: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number.isRequired,
    age: PropTypes.number.isRequired,
    residue: PropTypes.number.isRequired,
    felling_type: PropTypes.oneOf(['MANUAL', 'MECHANICAL']).isRequired,
    processing_type: PropTypes.oneOf(['MANUAL', 'MECHANICAL']).isRequired,
    extracted_mass: PropTypes.number,
    commercial_purpose:  PropTypes.oneOf(['PAPER', 'PLANK', 'SAW', 'STRUCTURAL']).isRequired
  })),
  plantings: PropTypes.arrayOf(PropTypes.shape({
    age: PropTypes.number.isRequired,
    number_per_ha: PropTypes.number.isRequired,
  })),
  regenerations: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number.isRequired,
    standing_number_per_ha: PropTypes.number.isRequired,
  })),
  clearings: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number.isRequired,
    age: PropTypes.number.isRequired,
  })),
  weedings: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number.isRequired,
    age: PropTypes.number.isRequired,
  })),
  prunings: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number.isRequired,
    age: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['HIGHT', 'LOW']).isRequired,
  })),
  prediction: PropTypes.array
});